import { render, staticRenderFns } from "./ViewFaq.vue?vue&type=template&id=5fe46dda&scoped=true&"
import script from "./ViewFaq.vue?vue&type=script&lang=js&"
export * from "./ViewFaq.vue?vue&type=script&lang=js&"
import style0 from "./ViewFaq.vue?vue&type=style&index=0&id=5fe46dda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe46dda",
  null
  
)

export default component.exports